import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import iView from 'iview'
import axios from 'axios'
import 'iview/dist/styles/iview.css'
import './permission'
import './global.js'
import echarts from 'echarts'
import wx from 'weixin-jsapi'
import lrz from 'lrz';
import JsonExcel from 'vue-json-excel'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// const ah = require("ajax-hook")
// var that = this;
// ah.hookAjax({
//     //拦截回调
//     onreadystatechange: function (xhr) {
//         console.log("onreadystatechange called: %O", xhr)
//     },
//     onload: function (xhr) {
//         console.log("onload called: %O", xhr.xhr.response)

//         let rpObject = JSON.parse(xhr.xhr.response);
//         console.log(rpObject.errorCode != 0);
//         if (rpObject.errorCode == 901) {
//             // that.$Notice.info({
//             //     title: "提示",
//             //     desc: "登录超时，请重新登录2！"
//             // });
//             localStorage.setItem("token", "");
//             localStorage.setItem("userImg", "");
//             localStorage.setItem("permissions", "");
//             localStorage.setItem("userName", "");
//             localStorage.setItem("isAdmin", false);
//             resetRouter();
//             that.$router.replace({ name: "login" });
//             return false;
//         }
//     },
//     //拦截函数
//     open: function (arg) {
//         console.log("open called: method:%s,url:%s,async:%s", arg[0], arg[1], arg[2])
//     }
// })

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.use(iView)
Vue.use(ElementUI)
Vue.component('downloadExcel', JsonExcel)

// 设置基础URL
axios.defaults.baseURL = ''
// 设置请求超时时间
axios.defaults.timeout = 5000

Vue.prototype.$axios = axios

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})